// react
import { useState } from 'react';

// types
import { Entity, LoadingStatus, UserPayload } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormOnboardUsers } from '../../forms/FormOnboardUsers/FormOnboardUsers';

// props
export interface DialogOnboardUsersProps {
	entity: Entity;
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
	usersWbg: UserPayload[];
}

export const DialogOnboardUsers = ({
	entity,
	isOpen,
	onClose,
	onSuccess,
	usersWbg,
}: DialogOnboardUsersProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [status, setStatus] = useState<LoadingStatus>('DEFAULT');

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
					variant: 'text',
				},
				{
					children: t('onboardUsers'),
					disabled: status === 'DISABLED',
					form: 'form-onboard-users',
					loading: status === 'LOADING',
					type: 'submit',
					variant: 'contained',
				},
			]}
			alignItems="center"
			hasClose={true}
			IconCircleProps={{
				type: 'user',
			}}
			isOpen={isOpen}
			maxWidth={580}
			onClose={onClose}
			subtitle={{
				children: entity?.name,
			}}
			title={{
				children: t('onboardUsers'),
			}}>
			<FormOnboardUsers
				entity={entity}
				onClose={onClose}
				onSuccess={onSuccess}
				setStatus={setStatus}
				usersWbg={usersWbg}
			/>
		</DialogActions>
	);
};
